import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MeetingInformation from 'Components/UI/MeetingInformation/MeetingInformationTooltip';
import Typography from 'Components/UI/Typography';

import PreviousEmail from './PreviousEmail';

const styles = () => ({
  root: {},
  rootEmpty: {
    display: 'flex',
    height: '100px',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const PreviousEmailsView = ({
  className,
  classes,
  householdResource,
  meetingResource,
}) => {
  const agendaResources = meetingResource.attr('agendas')
    .resources()
    .list()
    .filter(agendaResource => !!agendaResource.attr('sentTime'));
  const isEmpty = agendaResources.length === 0;

  return (
    <div
      className={classNames(classes.root, className, {
        [classes.rootEmpty]: isEmpty,
      })}
    >
      <MeetingInformation
        householdResource={householdResource}
        meetingResource={meetingResource}
      />
      {agendaResources.sort((a, b) => moment(b.attr('sentTime')).diff(moment(a.attr('sentTime'))))
        .map((agendaResource) => {
          return (
            <PreviousEmail
              key={agendaResource.id()}
              agenda={agendaResource}
            />
          );
        })
      }
      {isEmpty ? (
        <Typography
          variant="h5"
        >
          {'No Agendas'}
        </Typography>
      ) : null}
    </div>
  );
};

PreviousEmailsView.defaultProps = {
  className: '',
};

PreviousEmailsView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  householdResource: PropTypes.object.isRequired,
  meetingResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(PreviousEmailsView);
